module.exports = __webpack_public_path__ + "img/gaku_text_10.d66cb2ff.png";